import React from 'react'
import { GridSemaforoPure } from '../../pures'

const RepseStatusByCompanyCompanyView = (props) => {
    return (
        <div className='fadeIn'>
            <GridSemaforoPure
                columnTitle={"Empresa"}
                dataItems={props.companies}
                buttonTitle={"Ver estatus"}
                onButtonClick={(company) => props.onCompanySelected(company)}
                getColorByStatus={(status) => props.getColorByStatus(status)}
                yearShown={props.yearShown}
            />
        </div>
    )
}

export default RepseStatusByCompanyCompanyView